import { CoreStore } from '../../../../core/store/core.store';
import { ForgotPasswordError, LoginService } from '../../services/login.service';
import { getLoginUser } from '../../store/login.selectors';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { I18nService } from '@ppl/i18n';
import { KEYCODE_ENTER } from '@ppl/utils/keycode.utils';
import { PplValidators } from '@ppl/utils/validators.utils';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import type { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'ppl-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ForgotPasswordComponent {
  sending$ = new BehaviorSubject(false);

  description$: BehaviorSubject<string>;
  error$ = new BehaviorSubject<ForgotPasswordError>(ForgotPasswordError.NO_ERROR);

  resetPasswordLinkSent = false;

  emailForm: UntypedFormGroup;

  ForgotPasswordError = ForgotPasswordError;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private store: CoreStore,
    private loginService: LoginService,
    private i18nService: I18nService
  ) {
    this.emailForm = this.createForm();

    this.description$ = new BehaviorSubject(
      this.i18nService.translate('ForgotPassword_Description')
    );
  }

  createForm() {
    const user = this.store.get(getLoginUser);
    return this.fb.group({
      email: [user.email || '', [Validators.required, PplValidators.email]]
    });
  }

  onKeyUp(event) {
    if (event.which === KEYCODE_ENTER) {
      this.onSubmit();
    }
  }

  onGoBack() {
    this.router.navigate(['login']);
  }

  onSubmit() {
    this.error$.next(ForgotPasswordError.NO_ERROR);
    if (this.emailForm.valid) {
      const { email } = this.emailForm.value;
      this.sending$.next(true);
      this.loginService.forgotPassword(email)
        .pipe(
          finalize(() => {
            this.sending$.next(false);
          })
        ).subscribe(
          () => {
            this.resetPasswordLinkSent = true;
            this.description$.next(
              this.i18nService.translate('ForgotPassword_LinkSent')
            );
          },
          (error: ForgotPasswordError) => {
            this.error$.next(error);
          }
        );
    }
  }

}
